<!--
@author: 赵静静
@time: 2021/10/28
@desc:  待投标
-->
<template>
 <div class="distributionInfo">
   <div class="projectName">{{ project.name }}</div>
   <el-tabs type="border-card" @tab-click="tabClick" v-model="active">
     <el-tab-pane v-for="(item, index) in projectTitleList" :key="index" :label="item.title" :name="item.name">
       <div class="evaluate-div" v-if="item.name === '1'">
         <div v-if="list.length === 0 " class="noContent">
           <img src="../../assets/img/public/blank_icon_none.png">
         </div>
         <div class="basic evaluate-content" v-for="(item, index) in list" :key="index">
           <div class="evaluate-title">{{item.name}}</div>
         </div>
       </div>
       <div v-else>
         <div class="project-info" v-if="project.isChange === 2">
           <projectInfo :project="project" :isMyRelease="'1'" :isEdit="1"/>
         </div>
         <div class="project-info" v-else>
           <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
           <projectInfo :project="project" :isMyRelease="'1'"/>
           <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
           <projectInfo :project="project.oldInfo" :isMyRelease="'1'" :oldInfo="1"/>
           <div class="button">
             <el-button type="primary" @click="editProject" class="btnHeight_40 btWith_120">修改</el-button>
             <el-button type="warning" @click="revocation" class="btnHeight_40 btWith_120 mg_left_40">撤销</el-button>
           </div>
         </div>
       </div>
     </el-tab-pane>
   </el-tabs>


   <el-dialog
     title="撤销原因"
     :visible.sync="revocationDialog"
     width="30vw"
     center
   >
     <el-input v-model="reason" type="textarea" placeholder="请输入撤销原因"></el-input>
     <div slot="footer">
       <el-button type="info" @click="closeModal" class="btnHeight_40 btWith_120">取消</el-button>
       <el-button type="primary" @click="revocationConfirm" class="btnHeight_40 btWith_120">确定</el-button>
     </div>
   </el-dialog>

 </div>
</template>

<script>
import { getSignCompany } from '@api/public'
import { getNormalProjectInfo, changeCancel } from '@api/project'
import projectInfo from '@views/components/projectInfo'
export default {
  name: 'distributionInfo',
  components: { projectInfo },
  data () {
    return {
      active: '1',
      projectTitleList: [
        { name: '1', title: '报名用户' },
        { name: '2', title: '项目详情' }
      ],
      list: [],
      project: {},
      revocationDialog: false,
      reason: ''
    }
  },
  created () {
    this.getNormalProjectInfo()
    this.getSignCompany()
  },
  methods: {
    tabClick () {
      if (this.active === '1') {
        this.getSignCompany()
      } else if (this.active === '2') {
        // 获取项目详情
        this.getNormalProjectInfo()
      }
    },
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.$route.query.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 报名用户
    getSignCompany () {
      getSignCompany({
        projectId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editProject () {
      this.enterRouter('editBiaoZhunPage', { projectId: this.project.id })
    },
    revocation () {
      this.revocationDialog = true
    },
    closeModal () {
      this.revocationDialog = false
      this.reason = ''
    },
    revocationConfirm () {
      if (!this.reason) {
        this.$message.error('请输入撤销原因')
        return false
      }
      changeCancel({
        id: this.project.id,
        reason: this.reason
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('撤销成功！')
          this.reason = ''
          this.$router.go(-1)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .distributionInfo{
    width: 75%;
  .evaluate-div {
    padding: 24px 0;
    color: #333333;
  }
  .evaluate-title {
    font-size: 20px;
    margin-bottom: 16px;
  }
  .timeTitle{
    color: #999999;
    font-size: 18px;
    margin-right: 10px;
  }
    .button{
      width: 280px;
      margin: 0 auto;
      margin-bottom: 40px;
    }
  }
</style>
